import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* therapistMigrateTaskSaga(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistSchedulingServices.migrateTherapistAssignedTask, {
      providerId: action.payload?.providerId,
      sourceTherapist: action.payload?.sourceTherapist,
      targetTherapist: action.payload?.targetTherapist,
      taskId: action.payload?.taskId,
      singleAssign: true,
      assignDate: action.payload?.currentDate,
    });

    if (response?.status === 200) {
      yield put({ type: TherapistAction.THERAPIST_TASK_MIGRATE_SUCCESS, payload: response.data });

      if (action.payload.sourcePage !== action.payload.destinationPage) {
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
          payload: {
            pageNo: action.payload.destinationPage,
            data: {
              providerId: action.payload.meta.providerId,
              localDate: action.payload.meta.date,
              discipline: action.payload.meta.discipline,
              sortBy: action.payload.meta.sortBy,
              filterByUuid: action.payload?.filterByUuid,
            },
          },
        });
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
          payload: {
            pageNo: action.payload.sourcePage,
            data: {
              providerId: action.payload.meta.providerId,
              localDate: action.payload.meta.date,
              discipline: action.payload.meta.discipline,
              sortBy: action.payload.meta.sortBy,
              filterByUuid: action.payload?.filterByUuid,
            },
          },
        });
      } else {
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
          payload: {
            pageNo: action.payload.sourcePage,
            data: {
              providerId: action.payload.meta.providerId,
              localDate: action.payload.meta.date,
              discipline: action.payload.meta.discipline,
              sortBy: action.payload.meta.sortBy,
              filterByUuid: action.payload?.filterByUuid,
            },
          },
        });
        // }
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: TherapistAction.THERAPIST_TASK_MIGRATE_FAILURE, payload: error });
  }
}

function* therapistMigrateTaskSagaSaga() {
  yield takeEvery(TherapistAction.THERAPIST_TASK_MIGRATE_REQUEST, therapistMigrateTaskSaga);
}

export default therapistMigrateTaskSagaSaga;
